import { PremierServiceProductDTO } from "./premierServiceProductDTO";

export class PremierServiceDTO{
    public id!: number;
    public partnerId!: number;
    public name!: string;
    public serviceTypeId!: string;
    public status!: number;
    public enabled!: boolean;
    public parameterTemplate!: string;
    public productList!: PremierServiceProductDTO[];
    public added!: string;
    public edited!: string;

    constructor(){
        this.productList = [];
    }
}